import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Dashboard from './pages/Dashboard.tsx';
import Login from './pages/Login.tsx';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import PublicRoute from './components/PublicRoute.tsx';
import Layout from './components/Layout';
import NotificationsHistory from './pages/NotificationsHistory';
import DevicesPage from './pages/Devices';
import SettingsPage from './pages/Settings';
import Reports from './pages/Reports';
import Leaders from './pages/Leaders';
import Admin from './pages/Admin';
import AdminUsers from './pages/AdminUsers';
import AdminApps from './pages/AdminApps';

// Заглушки для новых страниц
const Devices = DevicesPage;
const Settings = SettingsPage;
const Logout = () => <div className="p-8">Выход (в разработке)</div>;

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="dark bg-[#141416] min-h-screen">
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/devices" element={<Devices />} />
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/leaders" element={<Leaders />} />
                      <Route path="/notifications" element={<NotificationsHistory />} />
                      <Route path="/admin" element={<Admin />} />
                      <Route path="/admin/users" element={<AdminUsers />} />
                      <Route path="/admin/apps" element={<AdminApps />} />
                      
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="bottom-right" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 